module.exports = __webpack_public_path__ + "static/media/audio-rockford-fosgate.12e9af6e.jpg";